import React from "react";

const Chat = (props) => {
    return (
        <>Chat</>
    )
}

export default Chat;